// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    AddressV1AddressVerifyAddressResponse,
    EdgeAddressModel,
    GatewayError,
    SaveAddressRequestModel,
    SaveAddressResponseModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeAddressApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param saveAddressRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async addressSaveAddress (saveAddressRequestModel: SaveAddressRequestModel, xProgramId?: string): Promise<AxiosResponse<SaveAddressResponseModel>> {
        const _url_ = '/edge/address/v1/address/saveAddress';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'saveAddressRequestModel' is not null or undefined
        if (saveAddressRequestModel === null || saveAddressRequestModel === undefined) {
            throw new Error('Required parameter saveAddressRequestModel was null or undefined when calling addressSaveAddress.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(saveAddressRequestModel, "SaveAddressRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SaveAddressResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SaveAddressResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param edgeAddressModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async addressVerifyAddress (edgeAddressModel: EdgeAddressModel, xProgramId?: string): Promise<AxiosResponse<AddressV1AddressVerifyAddressResponse>> {
        const _url_ = '/edge/address/v1/address/verifyAddress';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'edgeAddressModel' is not null or undefined
        if (edgeAddressModel === null || edgeAddressModel === undefined) {
            throw new Error('Required parameter edgeAddressModel was null or undefined when calling addressVerifyAddress.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(edgeAddressModel, "EdgeAddressModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AddressV1AddressVerifyAddressResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AddressV1AddressVerifyAddressResponse");
        }
        return response;
    }
}
